<div class="card" *ngIf="totalRegistros > 0">
    <div class="card-block">
        <div class="table-font-color table-pad-10 table-responsive">
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>
                            Número de Transacción
                        </th>
                        <th>
                            Número de Contrato
                        </th>
                        <th>
                            Cliente
                        </th>
                        <th>
                            Instrumento
                        </th>
                        <th>
                            Divisa
                        </th>
                        <th>
                            Tipo de Transacción
                        </th>
                        <th>

                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let transaccion of transaccionesResultados; let i = index">
                        <th scope="row">{{transaccion.referencia}}</th>
                        <td>{{transaccion.contrato}}</td>
                        <td>{{transaccion.nombre}} {{transaccion.sNombre}}
                            {{transaccion.apellidoPaterno}} {{transaccion.apellidoMaterno}}</td>
                        <td>{{transaccion.instrumento}}</td>
                        <td>{{transaccion.divisa}}</td>
                        <td>
                            {{ transaccion.tipoOperacion }}
                        </td>
                        <td class="text-center">
                            <input type="checkbox" name="chkTran-{{ i }}"
                                (change)="onItemChange($event.target.checked, transaccion)">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row table-pad-10 ">
        <div class="col ">
            Página {{ transacciones.Pagina }} de {{numPage}} <br /> Total {{totalRegistros}}
        </div>
        <div class="col" *ngIf="totalRegistros > 15">
            <nav aria-label="Page navigation example ">
                <ul class="pagination justify-content-end ">
                    <li class="page-item ">
                        <button class="page-link btn " (click)="paginador(false) " tabindex="-1"
                            [disabled]="this.transacciones.Pagina <= 1">Regresar</button>
                    </li>
                    <li class="page-item ">
                        <button class="page-link btn " (click)="paginador(true)"
                            [disabled]="this.totalRegistros < 15 || this.transacciones.Pagina == this.numPage">Siguiente</button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>

</div>
<!-- Both borders table end -->